var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"min-h-screen overflow-x-hidden text-white bg-white dark:text-gray-200 dark:bg-black transition duration-200 ease-in-out",attrs:{"id":"app"}},[_c('Nav'),_c('router-view'),_c('Footer',{staticClass:"w-full border border-true-gray-300 dark:border-true-gray-900"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }